export const errors = {
  not_found: {
    title: 'Niet gevonden!',
    description: 'Deze pagina kon niet gevonden worden',
    action: 'Terug naar home',
  },
}
